/************************************
MODULE:         Social buttons
WHAT IT DOES:   initializes all the social/like buttons
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
  

    function init() {
        var socialBlocks = $('.js-social-likes');
        if (!socialBlocks.length)
            return;


        require.ensure([], function () {
            var sociallikes = require('social-likes'),
                timeout = null;
            socialBlocks.on('popup_closed.social-likes', function (event, service) {
                if (timeout)
                    clearTimeout(timeout);
                timeout = setTimeout(function () {
                    for (var i = 0, l = socialBlocks.length; i < l; i++) {
                        socialBlocks.eq(i).socialLikes({ forceUpdate: true });
                    }
                }, 1000);
            });
        }, 'blog');

    }

    return {
        init: init
    }

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.social.js
 ** module id = 59
 ** module chunks = 24
 **/